"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { ConversationList } from "./ConversationList";
import { useMessaging } from "@/providers/messaging-provider";
import { useAuth } from "@/providers/auth-provider";

interface MobileMessengerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileMessengerSheet({
  open,
  onOpenChange,
}: MobileMessengerSheetProps) {
  const router = useRouter();
  const { user } = useAuth();
  const { state, actions } = useMessaging();

  // Load conversations when sheet opens
  useEffect(() => {
    if (open && user) {
      actions.loadConversations();
    }
  }, [open, user]);

  const handleSelectConversation = (conversation: any) => {
    onOpenChange(false); // Close sheet
    router.push(`/local-links-v1/messages/${conversation.id}`);
  };

  const handleNewMessage = () => {
    onOpenChange(false);
    router.push("/local-links-v1/messages/new");
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-[70vh] rounded-t-xl px-0">
        <SheetHeader className="px-4 pb-2 border-b">
          <div className="flex items-center justify-between">
            <SheetTitle>Messages</SheetTitle>
            <Button
              onClick={handleNewMessage}
              size="sm"
              className="gap-1 bg-green-600 hover:bg-green-700"
            >
              <Plus className="h-4 w-4" />
              New
            </Button>
          </div>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto">
          <ConversationList
            conversations={state.conversations}
            onSelectConversation={handleSelectConversation}
            isLoading={state.isLoading}
            currentUserId={user?.id || ""}
            searchQuery=""
            onSearchChange={() => {}}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
